import { useTranslation } from 'react-i18next'
import { supportedLanguages } from '../i18n/index.js'

export default function LanguageSwitcher() {
  const { t, i18n } = useTranslation('common')
  const currentLanguage = i18n.resolvedLanguage?.split('-')[0] ?? 'en'

  return (
    <label className="language-switcher">
      <span aria-hidden="true">🌐</span>
      <span className="sr-only">{t('language.label')}</span>
      <select
        value={currentLanguage}
        onChange={(event) => i18n.changeLanguage(event.target.value)}
        aria-label={t('language.label')}
      >
        {supportedLanguages.map((language) => (
          <option value={language} key={language}>{t(`language.${language}`)}</option>
        ))}
      </select>
    </label>
  )
}
